import path from 'path';
import type { BundleRequest } from '../types/BundleRequest.js';

interface IsCachedResultValidOptions {
  bundleRequest: BundleRequest;
  hash?: string;
}

/**
 * Validates the result of a bundle request.
 * @param options - The options to use when validating the result.
 * @returns True if the result is valid, false otherwise.
 */
export function isCachedResultValid(options: IsCachedResultValidOptions): boolean {
  const { bundleRequest, hash } = options;
  const { disableCache, isExternal, result } = bundleRequest;

  if (disableCache) {
    // The result is not valid if disableCache is true.
    return false;
  }

  if (!result) {
    // The result is undefined, so the result is invalid
    return false;
  }

  if (result.errors?.length) {
    // There are errors, so the result is invalid
    return false;
  }

  if (!result.outputPath) {
    // outputPath used to be an optional field, however, we do not want it to be undefined anymore.
    return false;
  }

  if (!isExternal && (result.hash == undefined || result.hash != hash)) {
    // Internal packages are invalid if the package hash has changed or it is undefined.
    return false;
  }

  // Output files must be relative
  if (result.outputFiles?.find(({ outputPath }) => path.isAbsolute(outputPath))) {
    return false;
  }

  return true;
}
